export const getTicketErrorMessage = (error, action = "alterar o atendimento") => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (status === 401) return "Sua sessão expirou. Entre novamente para continuar.";
  if (status === 403) return "Você não tem permissão para esta ação. O atendimento pode estar com outro atendente.";
  if (status === 404) return "Atendimento não encontrado. Atualize a lista de atendimentos.";
  if (status === 409) return "O atendimento foi assumido, movido ou finalizado. Atualize a tela antes de continuar.";
  if (status === 422) return "Revise os campos obrigatórios antes de continuar.";
  if (status === 429) return "Há muitas solicitações em andamento. Aguarde um momento e atualize a tela.";
  if (status >= 500) return `O servidor não conseguiu confirmar a ação de ${action}. Atualize a tela para conferir o estado do atendimento antes de tentar novamente.`;
  if (!error?.response) {
    const reason = ["ECONNABORTED", "ETIMEDOUT"].includes(error?.code)
      ? "O servidor demorou para responder."
      : "A conexão com o servidor foi interrompida.";
    return `${reason} Não foi possível confirmar a ação de ${action}. Atualize a tela antes de tentar novamente.`;
  }
  return `Não foi possível ${action}. Atualize a tela e tente novamente.`;
};

export const getClosureToast = (ticket, potential = false) => {
  if (ticket?.closure_notification_status !== "sent") {
    return {
      title: potential ? "Contato encerrado, com aviso" : "Atendimento finalizado, com aviso",
      description: ticket?.closure_notification_status === "partial"
        ? "O atendimento foi finalizado, mas a pesquisa de satisfação não teve o envio confirmado pelo WhatsApp."
        : "O atendimento foi encerrado, mas o WhatsApp não confirmou o envio da mensagem ao cliente. Confira a conexão do WhatsApp.",
      duration: 10000,
    };
  }
  return {
    title: potential ? "Contato encerrado" : "Atendimento finalizado",
    description: potential
      ? "Mensagem de encerramento enviada ao cliente, sem solicitar avaliação."
      : "Protocolo e pesquisa de satisfação enviados ao cliente.",
    duration: 4000,
  };
};
